import {Reducer} from "redux";
import {createLayerSource} from "./createLayerSource";
import {IApplicationState} from "../types";

const reducer: Reducer<any> = (state: IApplicationState['map'], action) => {
    const layerType = action.payload.layerType;
    const layerState = {...state.layerState};
    const layersByType = state.layersByType;
    const layerKeys = layerType ? [layerType] : Object.keys(layersByType)
    let mapStyle = state.mapStyle;
    layerKeys.forEach((layerName: string) => {
        const geoType = layersByType[layerName]?.properties?.geoType;
        mapStyle = createLayerSource(mapStyle, layersByType, layerName, geoType);
        layerState[layerName] = { ...layerState[layerName], isLoading: false };
        // reset layers by type
        delete layersByType[layerName];
    });

    return {...state, layersByType, layerState, mapStyle};
}

export { reducer as loadLayerDataCompleted };
